import React from "react";
import { Route, Switch, Redirect } from "react-router-dom"; //make sure to import all the components.
import Layout from "./hoc/layout";
import Home from "./containers/home/Home.js";
import SearchProjects from "./containers/searchProjects/SearchProjects.js";
import NewProject from "./containers/NewProject/NewProject";
import ProductShopping from "./containers/ProductShopping/ProductShopping2";
import Settings from "./containers/Settings/Settings";
import ProjectQuote from "./containers/ProjectQuote/ProjectQuote";
import UserProfile from "./containers/Settings/UserProfile/UserProfile";
import ApplicationSettings from "./containers/Settings/ApplicationSettings/UserSettings";
import DefaultProject from "./containers/Settings/DefaultProject/DefaultProject";
import Reports from "./containers/Settings/Reports/Reports";
import Pricing from "./containers/Settings/Pricing/Pricing";
import PictureBookCustomerSettings from "./containers/Settings/PictureBookCustomerSettings/PictureBookCustomerSettings";
import PictureBookWarehouseSettings from "./containers/Settings/PictureBookWarehouseSettings/PictureBookWarehouseSettings";
import RoomTitleSettings from "./containers/Settings/RoomTitleSettings/RoomTitleSettings";
import ProductGroups from "./containers/Settings/ProductGroups/ProductGroups";
import Negotiations from "./containers/ProjectQuote/Negotiations/Negotiations";
import NegotiationsPrint from "./containers/ProjectQuote/Negotiations/NegotiationsPrint";
import EditProductGroup from "./containers/Settings/ProductGroups/EditProductGroup";
import ProjectSummary from "./containers/ProjectSummary/ProjectSummary";
import QuoteReport from "./containers/Settings/Reports/QuoteReport/QuoteReport";
import StandardReport from "./containers/Settings/Reports/StandardReport/StandardReport";
import TransferProject from "./containers/Settings/TransferProject/TransferProject";
import DeleteProject from "./containers/Settings/DeleteProject/DeleteProject";
import EditConsultant from "./containers/Settings/EditConsultant/EditConsultant";
import NewConsultant from "./containers/Settings/NewConsultant/NewConsultant";
import Regions from "./containers/Settings/Regions/Regions";
import Warehouses from "./containers/Settings/Warehouses/Warehouses";
import Translations from "./containers/Settings/Translations/Translations";
import Dashboard from "./containers/Settings/Dashboard/Dashboard";
import TestPage from "./containers/Test/TestPage";
import { connect } from "react-redux";

// The order of the routes matters -- !!!!!!!!VERY IMPORTANT!!!!!!!!!!!! --
function Routes() {
	const userToken = localStorage.getItem("token");
	let routes;
	if (userToken) {
		routes = (
			<Layout>
				<Switch>
					<Route path="/" exact component={SearchProjects} />
					<Route path="/test" exact component={TestPage} />
					<Route path="/search-projects" component={SearchProjects} />
					<Route path="/new-project" component={NewProject} />
					<Route path="/project" component={NewProject} />
					<Route path="/product-shopping" component={ProductShopping} />

					<Route path="/negotiations" component={Negotiations} />
					<Route path="/negotiations-print" component={NegotiationsPrint} />
					<Route path="/settings/product-groups/edit" component={EditProductGroup} />

					<Route path="/settings/product-groups" component={ProductGroups} />

					<Route
						path="/settings/picturebook-customer-settings"
						component={PictureBookCustomerSettings}
					/>
					<Route
						path="/settings/picturebook-warehouse-settings"
						component={PictureBookWarehouseSettings}
					/>

					<Route path="/settings/pricing" component={Pricing} />

					<Route
						path="/settings/reports/standard-reports/:reportType"
						component={StandardReport}
					/>
					<Route
						path="/settings/reports/quote-reporting/:reportType"
						component={QuoteReport}
					/>
					<Route path="/settings/reports" component={Reports} />

					<Route
						path="/settings/room-titles"
						component={RoomTitleSettings}
					/>

					<Route path="/project-quote" component={ProjectQuote} />
					<Route path="/project-summary/:id" component={ProjectSummary} />
					<Route path="/settings/default_project" component={DefaultProject} />
					<Route path="/settings/application_settings" component={ApplicationSettings} />
					<Route path="/settings/user_profile" component={UserProfile} />

					{localStorage.getItem("perm_extra_project_filters") && (
						<>
							<Route path="/settings/transfer-project" component={TransferProject} />
							<Route path="/settings/delete-project" component={DeleteProject} />
							<Route path="/settings/edit-consultant" component={EditConsultant} />
							<Route path="/settings/new-consultant" component={NewConsultant} />
							<Route path="/settings/regions" component={Regions} />
							<Route path="/settings/warehouses" component={Warehouses} />
							<Route path="/settings/translations" component={Translations} />
							<Route path="/settings/dashboard" component={Dashboard} />
							<Route path="/settings" exact component={Settings} />
						</>
					)}
					<Route path="/settings" component={Settings} />
				</Switch>
			</Layout>
		);
	} else {
		// Layout commented out just to hide it from showing when the page is first loaded before it redirects
		routes = (
			<Switch>
				<Route path="/" exact component={Home} />
				<Route render={() => <Redirect to="/" />} />
			</Switch>
		);
	}
	return routes;
}

const mapStateToProps = state => {
	return {
		user: state.user,
		initialLogin: state.initialLogin,
		admin: state.admin,
		selected_language_translations: state.language_translations, // Added so that the app reloads when translations are loaded
		selected_language: state.selected_language // Added so that the app reloads when the language is changed
	};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Routes);
